<template>
  <div>
    <div class="sidebar-container mt-50px">
      <h2 class="section-title">
        {{ selectedCommerce.properties.nom }}
      </h2>
      <div class="double-dashed-border"></div>
      <div class="organisation-info mt-20px">
        <div>
          <map-maker-icon class="organisation-icons text-blue" />
          {{ selectedCommerce.properties.adresse.address }}
        </div>
      </div>

      <div class="organisation-info mt-20px">
        <div><map-marker-path-icon class="organisation-icons text-blue" /></div>
        <div>
          <b><a :href="'https://www.google.ca/maps/dir/Current+Location/'+selectedCommerce.properties.adresse.address" target="_blank">Obtenir l'itinéraire</a></b>
        </div>
      </div>
    </div>
    <div class="sidebar-container mt-50px">
      <h2 class="section-title">
        Les fournisseurs suivants sont distribués dans cet établissement
      </h2>
      <div class="double-dashed-border"></div>
      <div class="mt-20px">
        <div
          class="element-business"
          v-for="(
            businessAvailable, index
          ) in selectedCommerce.businessAvailable"
          :key="index"
          @click="goToDistributor(businessAvailable.geometry.coordinates)"
        >
          <map-marker-left-icon />
          <div class="pl-10px">{{ businessAvailable.properties.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    selectedCommerce: Object,
    lmap: Object
  },
  methods: {
    goToDistributor (coordinates) {
      this.lmap.flyTo([coordinates[1], coordinates[0]], 17)
    }
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/InfoCommerce.vue